import { useEffect } from "react";
import { X } from "lucide-react";

/** Escape key closes the modal; `active` lets the caller disable while a save is in flight. */
export function useEscape(onClose, active = true) {
  useEffect(() => {
    if (!active || !onClose) return;
    const h = (e) => { if (e.key === "Escape") { e.stopPropagation(); onClose(); } };
    window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, [onClose, active]);
}

/** Always-available "x" in the top-right corner of a modal card. The card must be `relative`. */
export function ModalClose({ onClose, testid = "modal-close", label = "Close" }) {
  useEscape(onClose);
  return (
    <button type="button" onClick={onClose} aria-label={label} title={label} data-testid={testid}
      className="absolute top-3 right-3 z-10 w-9 h-9 rounded-full bg-stone-100/90 text-stone-500 hover:bg-stone-900 hover:text-white flex items-center justify-center transition-colors">
      <X className="w-4 h-4" />
    </button>
  );
}
